module.exports = __webpack_public_path__ + "img/rep-darcy.933b5fe7.png";